module.exports = __webpack_public_path__ + "static/media/friedegg.71050117.png";